import React, { useState, useRef, useEffect } from 'react';
import styles from './CalendarDropdown.module.scss';
import Text from '../../../../../../atoms/text/Text';

const arrowDown = '/assets/svg/cards/Arrow_Down.svg';

const CalendarDropdown = ({ CALENDAR_SUBTABS = [], subTab, setSubTab }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selected = CALENDAR_SUBTABS[subTab];

  return (
    <div className={styles['calendar-dropdown-wrapper']} ref={wrapperRef}>
      <button
        type="button"
        className={styles['calendar-dropdown-button']}
        onClick={() => setOpen(!open)}
      >
        <Text
          key={selected?.id ?? subTab}
          title={selected?.title}
          variant="text-regular-16"
          style={{ cursor: 'pointer' }}
        />
        <img
          src={arrowDown}
          alt="dropdown arrow"
          className={`${styles['dropdown-arrow']} ${open ? styles.open : ''}`}
        />
      </button>

      {open && (
        <ul className={styles['calendar-dropdown-list']}>
          {CALENDAR_SUBTABS.map((t, i) => (
            <li
              key={t.id}
              className={`${styles['calendar-dropdown-item']} ${
                i === subTab ? styles.active : ''
              }`}
              onClick={() => {
                setSubTab(i);
                setOpen(false);
              }}
            >
              <Text
                title={t.title}
                variant="text-regular-16"
                color="black"
                style={{ cursor: 'pointer' }}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CalendarDropdown;
